module.exports = __webpack_public_path__ + "static/img/8-5.ab527b11.jpg";